<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path
      d="M15.8734 11.5335L21 8.26677L15.8734 5V6.94523H3.00068V9.56584H15.8734V11.5335ZM8.12657 12.468L3 15.734L8.12657 19V17.0548H21V14.4342H8.12657V12.468Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconChange',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
